import {useConfig} from '@lore/config';
import getProjectShareUrl from '@/features/share-project/utils/getProjectShareUrl';

export default function useProjectShareActions(project) {
  const config = useConfig();
  const shareUrl = getProjectShareUrl(config, project);

  return {
    onEmail: () => {
      window.location.href = `mailto:?subject=${encodeURIComponent(project.data.title)}&body=${encodeURIComponent(shareUrl)}`;
    },
    onLinkedIn: () => {
      window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, '_blank');
    },
    onFacebook: () => {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
    },
    onCopyLink: () => {
      navigator.clipboard.writeText(shareUrl);
    }
  };
}
